import { render } from "./GavContracts.vue?vue&type=template&id=52f21944&ts=true"
import script from "./GavContracts.vue?vue&type=script&lang=ts"
export * from "./GavContracts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__